import React from "react";
import { IPackageDetailsItinerary } from "../interface/IPackageDetails.interface";

interface IOverview {
  overview: IPackageDetailsItinerary[];
}

const Overview = ({ overview }: IOverview) => {
  return (
    <div className="flex flex-col gap-8 pt-10">
      {overview.map((dayItem) => (
        <div
          key={dayItem?.id}
          className="flex flex-col md:flex-row md:gap-14 items-start"
        >
          <div className="flex-shrink-0">
            <div className="bg-yellow-400 rounded-r-3xl px-6 py-2 inline-block typography-large-body-regular font-medium whitespace-nowrap">
              Day {dayItem?.day}
            </div>
          </div>

          <div className="flex flex-col px-10 md:px-0 md:flex-row md:gap-6 mt-5 md:mt-0 flex-wrap">
            <span className="inline-flex w-44 md:w-72 gap-2 items-center font-semibold">
              {dayItem?.title}
            </span>
            <span
              className="text-gray-700"
              dangerouslySetInnerHTML={{
                __html: dayItem?.description || "",
              }}
            ></span>
            <hr className="w-full border-t border-grey-50 mt-6 mr-6" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Overview;
